<template>
  <div>
    <c-card title="LBLBASEINFO" class="cardClassDetailForm">
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant 
            :disabled="popupParam.isOld"
            :editable="editable"
            type="edit"
            name="plantCd" 
            v-model="popupParam.plantCd"
            @datachange="datachange" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :disabled="popupParam.isOld"
            :editable="editable"
            type="year"
            label="년도"
            name="year"
            v-model="popupParam.year"
            @datachange="datachange"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 q-ml-md" style="color:tomato; font-size: 0.95em;">
          ※ 동일 년도에 추가로 엑셀업로드 시 기존데이터를 전체 삭제 후 추가됩니다. <br/>
          ※ 대용량 엑셀 파일 처리 중이므로, 완료될 때까지 약 5분 정도 기다려주세요.
        </div>
      </template>
    </c-card>
    <!-- :data="filterData" -->
    <c-table
      ref="inout-table"
      class="q-mt-sm"
      :title="`${popupParam.year}년도 제조/수입/사용/판매 관리대장`"
      :editable="editable"
      :columns="gridColumns"
      :data="grid.data"
      :gridHeight="gridHeight"
      :columnSetting="false"
      :usePaging="false"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn v-if="printFlag" label="특별관리물질 관리대장 출력" icon="print" @btnClicked="print('S')" />
          <c-btn v-if="printFlag" label="유해물질 관리대장 출력" icon="print" @btnClicked="print('H')" />
          <c-btn v-if="editable" label="화학물질 관리대장 엑셀 파일 업로드" icon="upload" @btnClicked="openExcelUploader" />
        </q-btn-group>
      </template>
      <!-- <template slot="suffixTitle">
        <c-datepicker
          class="inout-facility"
          type="month"
          default="today"
          label=""
          name="month"
          v-model="filter.month"
        />
      </template> -->
      <template v-slot:customBottomRow>
        <q-tr 
          v-if="grid.data && grid.data.length > 0" 
          no-hover
          style="background-color: lightgray;position: sticky;bottom: 0; font-weight: bold;">
          <q-td
            class="text-center th-td-style th-style"
            :rowspan="1" :colspan="1">합 계
          </q-td>
          <q-td
            class="text-center th-td-style th-style"
            :rowspan="1" :colspan="1">
          </q-td>
          <q-td
            class="text-right th-td-style th-style"
            :rowspan="1" :colspan="1">
            <span>
              {{ $_.round($_.sumBy(grid.data, 'carryover'), 2) | toThousandFilter }}
            </span>
          </q-td>
          <q-td
            class="text-right th-td-style th-style"
            :rowspan="1" :colspan="1">
            <span>
              {{ $_.round($_.sumBy(grid.data, 'inAmount'), 2) | toThousandFilter }}
            </span>
          </q-td>
          <q-td
            class="text-center th-td-style th-style"
            :rowspan="1" :colspan="1">
          </q-td>
          <q-td
            class="text-right th-td-style th-style"
            :rowspan="1" :colspan="1">
            <span>
              {{ $_.round($_.sumBy(grid.data, 'outAmount'), 2) | toThousandFilter }}
            </span>
          </q-td>
          <q-td
            class="text-right th-td-style th-style"
            :rowspan="1" :colspan="1">
            <span>
              {{ $_.round($_.sumBy(grid.data, 'inventory'), 2) | toThousandFilter }}
            </span>
          </q-td>
          <q-td
            class="text-center th-td-style th-style"
            :rowspan="1" :colspan="1">
          </q-td>
        </q-tr>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'inout-management-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        plantCd: '',
        year: '',
        isOld: false,
      }),
    },
    contentHeight: {
      type: [Number, String],
      default: function() {
        return null;
      },
    },
  },
  data() {
    return {
      // filter: {
      //   month: null,
      // },
      grid: {
        data: [],
      },
      editable: true,
      listUrl: '',
      validUrl: '',
      printUrl: '',
      saveUrl: '',
      popupOptions: {
        isFull: false,
        width: '80%',
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    gridHeight() {
      let height = this.contentHeight - 170;
      if (height < 500) {
        height = 500;
      }
      return String(height) + 'px';
    },
    gridColumns() {
      return [
        {
          name: 'inoutDate',
          field: 'inoutDate',
          label: '전기일자',
          align: 'center',
          style: 'width:140px',
          sortable: true,
          start: `${this.popupParam.year}-01-01`,
          end: `${this.popupParam.year}-12-31`,
        },
        {
          name: 'materialName',
          field: 'materialName',
          label: '화학자재명',
          align: 'left',
          style: 'width:250px',
          sortable: false,
        },
        {
          name: 'in',
          field: 'in',
          label: '입고',
          align: 'center',
          child: [
            {
              name: 'carryover',
              field: 'carryover',
              label: '이월량',
              align: 'right',
              style: 'width:70px',
              sortable: false,
              type: 'cost'
            },
            {
              name: 'inAmount',
              field: 'inAmount',
              label: '입고수량',
              align: 'right',
              style: 'width:70px',
              sortable: false,
              type: 'cost'
            },
            {
              name: 'inVendorName',
              field: 'inVendorName',
              label: '입고처',
              align: 'center',
              style: 'width:220px',
              sortable: false,
            },
          ]
        },
        {
          name: 'outAmount',
          field: 'outAmount',
          label: '출고량',
          align: 'right',
          style: 'width:70px',
          sortable: false,
          type: 'cost'
        },
        {
          name: 'inventory',
          field: 'inventory',
          label: '재고량',
          align: 'right',
          style: 'width:70px',
          sortable: false,
          type: 'cost'
        },
        {
          name: 'remarks',
          field: 'remarks',
          label: '제조구분',
          align: 'left',
          style: 'width:150px',
          sortable: false,
        },
      ]
    },
    // filterData() {
    //   return this.grid.data.filter(
    //     data =>
    //       !this.filter.month
    //       || data.yearmonth.toLowerCase().includes(this.filter.month.toLowerCase())
    //   )
    // },
    printFlag() {
      return this.grid.data && this.grid.data.length > 0
    }
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.chm.inout.list.url;
      this.validUrl = selectConfig.chm.inout.valid.url;
      this.printUrl = selectConfig.chm.inout.print.url;
      this.saveUrl = transactionConfig.chm.inout.save.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      if (this.popupParam.plantCd && this.popupParam.year) {
        this.$http.url = this.listUrl;
        this.$http.type = 'GET';
        this.$http.param = {
          plantCd: this.popupParam.plantCd,
          year: this.popupParam.year
        }
        this.$http.request((_result) => {
          this.grid.data = _result.data;
        },);
      }
    },
    datachange() {
      if (this.popupParam.plantCd && this.popupParam.year && !this.popupParam.isOld) {
        this.$http.url = this.validUrl;
        this.$http.type = 'GET';
        this.$http.param = {
          plantCd: this.popupParam.plantCd,
          year: this.popupParam.year
        }
        this.$http.request((_result) => {
          if (_result.data > 0) {
            window.getApp.$emit('ALERT', {
              title: '안내 ', /* 안내 */
              message: '입력한 사업장과 년도에 이미 데이터가 존재합니다.\n[년도] 데이터를 다시 입력하세요.',
              type: 'warning', // success / info / warning / error
            });
            this.popupParam.year = null;
          } else {
            // nothing..
          }
        },);

      }
    },
    openExcelUploader() {
      if (!this.popupParam.plantCd || !this.popupParam.year) {
        window.getApp.$emit('ALERT', {
          title: '안내 ', /* 안내 */
          message: '사업장과 년도를 입력 후 이용바랍니다.',
          type: 'warning', // success / info / warning / error
        });
        return;
      }
      this.popupOptions.title = '화학물질 관리대장 엑셀 업로드';
      this.popupOptions.target = () => import(`${'./inoutManagementExcelUpload.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeExcelUploaderPopup;
    },
    closeExcelUploaderPopup(_result) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (_result && _result.length > 0) {
        let s_data = this.$_.filter(_result, (item) => { return !item.error_message })
        this.$_.forEach(s_data, item => {
          // item.plantCd = this.popupParam.plantCd;
          // item.year = this.popupParam.year;
          item.chmInTypeCd = 'CIT0000010';
          item.chmOutTypeCd = item.remarks === '재고실사차이출고' ? 'COT0000015' : 'COT0000001';
          item.regUserId = this.$store.getters.user.userId;
          item.editFlag = 'C';
          ['carryover','inAmount','outAmount','inventory'].forEach(key => { 
            item[key] = Number(String(item[key] || '').replace(/,/g,'')) || 0; 
          });
        })

        this.$http.url = this.saveUrl;
        this.$http.type = 'PUT';
        this.$http.param = {
          plantCd: this.popupParam.plantCd,
          year: this.popupParam.year,
          inouts: s_data
        }
        this.$http.timeout = 600000;
        this.$http.request(() => {
          window.getApp.$emit('APP_REQUEST_SUCCESS');
          this.popupParam.isOld = true;
          this.getList();
        },);
      }
    },
    print(flag) {
      let thisVue = this;
      this.$http.url = this.printUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.popupParam.plantCd,
        year: this.popupParam.year,
        searchFlag: flag
      };
      this.$http.request(
        _result => {
          if (_result.data) {
            let fileOrgNm = this.popupParam.year + '년도 제조/수입/사용/판매 관리대장(' + (flag === 'S' ? '특별관리물질' : '유해물질') + ').xlsx';
            let blob = thisVue.$comm.base64ToBlob(_result.data);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, fileOrgNm);
            } else {
              let link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = fileOrgNm;
              link.click();
            }
          } else {
            window.getApp.$emit('ALERT', {
              title: '안내', // 안내
              message: '관리대장에 입력된 화학자재 중 ' + (flag === 'S' ? '특별관리물질' : '유해물질') + '이 없습니다.',
              type: 'warning', // success / info / warning / error
            });
          }
        }, () => { }
      );
    },
  }
};
</script>
<style lang="sass">
.chem-inout-info 
  margin-top: -20px !important
.inout-facility
  display: inline-block
  label
    padding-bottom: 0px !important
  .q-field__inner
    padding-bottom: 0px !important
  .mx-input-wrapper
    margin: 0 !important
</style>